import { create } from "zustand";

export type PersoneelsdienstSchedulerJob = {
  ticket: string;
  startedAtMs: number;
  periodLabel: string;
};

type PersoneelsdienstSchedulerState = {
  activeJob: PersoneelsdienstSchedulerJob | null;
  startJob: (job: PersoneelsdienstSchedulerJob) => void;
  clearJob: () => void;
};

export const usePersoneelsdienstSchedulerStore = create<PersoneelsdienstSchedulerState>((set) => ({
  activeJob: null,

  startJob: (job) => set({ activeJob: job }),

  clearJob: () => set({ activeJob: null }),
}));
